/**
 * Created by chenzheyu on 2017/6/13.
 */
import XksiteInput from './src/siteInput.vue'

XksiteInput.install = function (Vue) {
  Vue.component(XksiteInput.name, XksiteInput)
}

export default XksiteInput



// WEBPACK FOOTER //
// ./src/components/module/siteInput/index.js